import { getOrganizationEndpoint } from '../../api/platform-client.js';
import { selectAdvancedSearchQueries } from '../../features/advanced-search-queries/advanced-search-query-selectors.js';
import { fromAnalyticsStateToAnalyticsParams } from '../../features/configuration/analytics-params.js';
import { selectContext } from '../../features/context/context-selector.js';
import { selectFieldsToIncludeInCitation } from '../../features/generated-answer/generated-answer-selectors.js';
import { selectPipeline } from '../../features/pipeline/select-pipeline.js';
import { selectQuery } from '../../features/query/query-selectors.js';
import { initialSearchMappings, mapFacetRequest, } from '../../features/search/search-mappings.js';
import { buildConstantQuery, getNumberOfResultsWithinIndexLimit, } from '../../features/search/search-request.js';
import { selectSearchActionCause } from '../../features/search/search-selectors.js';
import { selectSearchHub } from '../../features/search-hub/search-hub-selectors.js';
import { selectActiveTab } from '../../features/tab-set/tab-set-selectors.js';
import { getFacets } from '../../utils/facet-utils.js';
export const buildStreamingRequest = async (state) => ({
    accessToken: state.configuration.accessToken,
    organizationId: state.configuration.organizationId,
    url: getOrganizationEndpoint(state.configuration.organizationId, state.configuration.environment),
    streamId: state.search.extendedResults?.generativeQuestionAnsweringId,
});
export const constructAnswerAPIQueryParams = (state, navigatorContext) => {
    const q = selectQuery(state)?.q;
    const { aq, cq, dq, lq } = buildAdvancedSearchQueryParams(state);
    const context = selectContext(state);
    const analyticsParams = fromAnalyticsStateToAnalyticsParams(state.configuration.analytics, navigatorContext, { actionCause: selectSearchActionCause(state) });
    const searchHub = selectSearchHub(state);
    const pipeline = selectPipeline(state);
    const citationsFieldToInclude = selectFieldsToIncludeInCitation(state) ?? [];
    const facetParams = getGeneratedFacetParams(state);
    return {
        q,
        ...(aq && { aq }),
        ...(cq && { cq }),
        ...(dq && { dq }),
        ...(lq && { lq }),
        ...(context?.contextValues && {
            context: context.contextValues,
        }),
        pipelineRuleParameters: {
            mlGenerativeQuestionAnswering: {
                responseFormat: state.generatedAnswer.responseFormat,
                citationsFieldToInclude,
            },
        },
        ...(searchHub?.length && { searchHub }),
        ...(pipeline?.length && { pipeline }),
        // Passing facets
        ...(Object.keys(facetParams).length && { facets: facetParams }),
        ...(state.fields && { fieldsToInclude: state.fields.fieldsToInclude }),
        ...(state.didYouMean && {
            queryCorrection: {
                enabled: state.didYouMean.enableDidYouMean &&
                    state.didYouMean.queryCorrectionMode === 'next',
                options: {
                    automaticallyCorrect: state.didYouMean.automaticallyCorrectQuery
                        ? 'whenNoResults'
                        : 'never',
                },
            },
            enableDidYouMean: state.didYouMean.enableDidYouMean &&
                state.didYouMean.queryCorrectionMode === 'legacy',
        }),
        ...(state.pagination && {
            numberOfResults: getNumberOfResultsWithinIndexLimit(state),
            firstResult: state.pagination.firstResult,
        }),
        tab: selectActiveTab(state.tabSet),
        ...analyticsParams,
    };
};
const getGeneratedFacetParams = (state) => getFacets(state)
    ?.map((facetRequest) => mapFacetRequest(facetRequest, initialSearchMappings()))
    .sort((a, b) => a.facetId > b.facetId ? 1 : b.facetId > a.facetId ? -1 : 0);
const buildAdvancedSearchQueryParams = (state) => {
    const advancedSearchQueryParams = selectAdvancedSearchQueries(state);
    const mergedCq = buildConstantQuery(state);
    return {
        ...advancedSearchQueryParams,
        ...(mergedCq && { cq: mergedCq }),
    };
};
